import React from 'react';
import './DeviceStatus.css';

const DeviceStatus = ({ status }) => {
  if (!status) {
    return (
      <div className="device-status">
        <div className="empty-state">
          <p>No status data available for this device.</p>
        </div>
      </div>
    );
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    try {
      const date = new Date(timestamp);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
      });
    } catch (error) {
      return 'Invalid date';
    }
  };

  const getTimeSinceLastCheck = (timestamp) => {
    if (!timestamp) return null;
    try {
      const lastCheck = new Date(timestamp);
      const now = new Date();
      const diffMs = now - lastCheck;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMins / 60);
      const diffDays = Math.floor(diffHours / 24);

      if (diffDays > 0) {
        return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
      } else if (diffHours > 0) {
        return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
      } else if (diffMins > 0) {
        return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
      } else {
        return 'Just now';
      }
    } catch (error) {
      return null;
    }
  };

  const lastCheckTime = status.health_manager_last_check;
  const timeSince = getTimeSinceLastCheck(lastCheckTime);

  // Determine if status is stale (more than 1 hour old)
  const isStale = () => {
    if (!lastCheckTime) return false;
    const lastCheck = new Date(lastCheckTime);
    const now = new Date();
    const diffMs = now - lastCheck;
    const diffHours = diffMs / (1000 * 60 * 60);
    return diffHours > 1;
  };

  return (
    <div className="device-status">
      <div className={`status-bar ${isStale() ? 'stale' : 'active'}`}>
        <div className={`status-indicator ${isStale() ? 'stale' : 'active'}`} />
        <span className="status-text">
          <strong>Last Health Check:</strong> {formatDate(lastCheckTime)}
          {timeSince && <span className="time-since"> ({timeSince})</span>}
        </span>
      </div>
    </div>
  );
};

export default DeviceStatus;

